var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTimeStep48Filled = function SvgIconTimeStep48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 32c6.45 0 11.7-5.25 11.7-11.7 0-6.45-5.25-11.7-11.7-11.7-6.45 0-11.7 5.25-11.7 11.7C12.3 26.75 17.55 32 24 32Zm-1.7-17.71h3.4v5.27l3.03 3.03-2.4 2.4-3.18-3.18c-.54-.54-.85-1.29-.85-2.05v-5.48.01ZM36 33.2c-1.08 0-2.03.56-2.59 1.4h-6.82c-.55-.84-1.5-1.4-2.59-1.4a3.1 3.1 0 0 0-2.59 1.4h-6.82c-.55-.84-1.5-1.4-2.59-1.4-1.71 0-3.1 1.39-3.1 3.1 0 1.71 1.39 3.1 3.1 3.1 1.08 0 2.03-.56 2.59-1.4h6.82A3.1 3.1 0 0 0 24 39.4c1.08 0 2.03-.56 2.59-1.4h6.82A3.1 3.1 0 0 0 36 39.4c1.71 0 3.1-1.39 3.1-3.1 0-1.71-1.39-3.1-3.1-3.1Z",
    fill: "current"
  })));
};
export default SvgIconTimeStep48Filled;